<template>
    <div class="image-view">
        <div
            v-for="(image, indx) in images"
            :key="indx"
            @mouseover="$emit('update:hover-index', indx)"
            @mouseleave="$emit('update:hover-index', null)"
            class="image-wrapper"
        >
            <img :src="previewSrc(image)" :alt="`artist-image-${indx}`" class="image" />
            <span v-if="indx === profilePicIndx && editable" class="profile-pic"
                >Profile pic</span
            >
            <button
                v-if="indx !== profilePicIndx && editable"
                @click="$emit('update:profile-pic-indx', indx)"
                class="make-profile"
            >
                Make profile pic
            </button>
            <div v-if="hoverIndex === indx && editable" class="actions">
                <button
                    v-if="isFile(image)"
                    @click="$emit('delete-image', indx)"
                    class="delete-image"
                >
                    <img src="/images/icons/trash-can-yellow.svg" alt="delete" />
                </button>
                <button
                    v-if="isFile(image)"
                    @click="$emit('edit-photo', image)"
                    class="edit-image"
                >
                    <img src="/images/icons/edit-yellow.svg" alt="edit" />
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ImageView',
        props: {
            images: {
                type: Array,
                required: false,
                default: () => []
            },
            profilePicIndx: {
                type: Number,
                required: true
            },
            hoverIndex: {
                type: Number,
                required: false
            },
            editable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        emits: ['delete-image', 'edit-photo', 'update:profile-pic-indx', 'update:hover-index'],
        computed: {
            previewSrc() {
                return (media) => {
                    if (media instanceof File) {
                        return URL.createObjectURL(media)
                    } else {
                        return media.src
                    }
                }
            },
            isFile() {
                return (image) => {
                    return image instanceof File
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .image-view {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 12px;

        .image-wrapper {
            position: relative;

            .image {
                border-radius: 8px;
                width: 194px;
                height: 109px;
                object-fit: cover;
            }
            .profile-pic,
            .make-profile,
            .actions {
                position: absolute;
                top: 5px;
                right: 5px;
            }
            .actions {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                gap: 4px;
            }
            .profile-pic {
                padding-top: 5px;
                padding-bottom: 5px;
                color: #cdeb09;
                @include base-font-14;
                font-weight: 400;
                left: 10px;
            }
            .make-profile {
                padding-top: 5px;
                padding-bottom: 5px;
                background: none;
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                left: 10px;
            }
            .edit-image,
            .delete-image {
                padding-left: 0px;
                padding-right: 0px;
                background: none;
                right: 10px;

                img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                }
            }
        }
    }
</style>
